import Base from 'app/views/base';

import tmpl from 'templates/purchase-confirmation';
import { setLocation } from 'utils/wrappers';
import { showResponseError } from 'utils/messages';
import Subscription from 'app/models/subscription';


export default Base.extend({
  compiledTemplate: tmpl,
  className: 'billing',

  initialize() {
    this.model = new Subscription();
  },

  events: {
    'click #confirm-purchase': 'confirmPurchase',
  },

  context() {
    const { id, quantity, interval, name, price } = this.model.get('plan');
    return {
      planId: id,
      planQuantity: quantity,
      planInterval: interval,
      planName: name,
      planPrice: price,
      nextPaymentDate: this.model.getNextPaymentDate(),
    };
  },

  confirmPurchase() {
    this.model.save(null, {
      success(){
        setLocation('/checkout/success');
      },
      error(model, response) {
        showResponseError(response);
      },
    })
  },
});



// WEBPACK FOOTER //
// ./app/views/purchase_confirmation_page.js